import { useGetTranscriptTypesQuery } from '@/types/vue-apollo-helpers';

export const useTranscriptTypes = () => {
  const { result, loading, refetch, error } = useGetTranscriptTypesQuery({
    fetchPolicy: 'cache-and-network',
  });

  const types = computed(() => result.value?.transcriptTypes ?? []);

  return { types, loading, refetch, error };
};
